import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpHandler,
    HttpRequest,
    HttpHeaders,
} from '@angular/common/http';
import { from, Observable, throwError } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
/* "Barrel" of Http Interceptors */
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { OpenIdService } from './open-id.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class HttpInterceptService implements HttpInterceptor {
    constructor(private openIdService: OpenIdService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
        return from(this.openIdService.keycloak.updateToken(30)).pipe(() => {
            let token = String(this.openIdService.keycloak.token);
            let authReq = req.clone({
                headers: new HttpHeaders().set(
                    'Authorization',
                    `Bearer ${token}`
                ),
            });

            if (!/^http/.test(authReq.url)) {
                authReq = authReq.clone({
                    url: `${environment.apiUrl}/${authReq.url}`,
                });
            }

            return next.handle(authReq).pipe(
                tap({
                    // Succeeds when there is a response; ignore other events
                    next: (event) => {},
                    // Operation failed; error is an HttpErrorResponse
                    error: (error) => {
                        let msg = `Alarm! ${error.url} returned ${error.status}`;
                        if ('error' in error && 'message' in error.error) {
                            msg = `${msg} [${error.error.message}]`;
                        }

                        return throwError(() => new Error(msg));
                    },
                }),
                finalize(() => {})
            );
        });
    }
}

export const httpInterceptProviders = [
    { provide: HTTP_INTERCEPTORS, useClass: HttpInterceptService, multi: true },
];
